module.exports = __webpack_public_path__ + "static/modal-columb-266f24133a09602013dd0fd22095aa7c.jpg";